import '../ui-anchor/ui-anchor.lv';
import '../ui-annotation/ui-annotation.lv';
import '../ui-assets/ui-assets.lv';
import '../ui-autocomplete/ui-autocomplete.lv';
import '../ui-breadcrumbs/ui-breadcrumbs.lv';
import '../ui-button/ui-button.lv';
import '../ui-calendar/ui-calendar.lv';
import '../ui-chip/ui-chip.lv';
import '../ui-comparison-cards/ui-comparison-cards.lv';
import '../ui-countdown/ui-countdown.lv';
import '../ui-curtain/ui-curtain.lv';
import '../ui-datepicker/ui-datepicker.lv';
import '../ui-daterange/ui-daterange.lv';
import '../ui-dialogbubble/ui-dialogbubble.lv';
import '../ui-dropdown/ui-dropdown.lv';
import '../ui-feedback/ui-feedback.lv';
import '../ui-field/ui-field.lv';
import '../ui-footer/ui-footer.lv';
import '../ui-form/ui-form.lv';
import '../ui-message/ui-message.lv';
import '../ui-modal/ui-modal.lv';
import '../ui-monthpicker/ui-monthpicker.lv';
import '../ui-nav/ui-nav.lv';
import '../ui-navitem/ui-navitem.lv';
import '../ui-navlist/ui-navlist.lv';
import '../ui-navtoggle/ui-navtoggle.lv';
import '../ui-offer/ui-offer.lv';
import '../ui-salesribbon/ui-salesribbon.lv';
import '../ui-pagination/ui-pagination.lv';
import '../ui-phonefield/ui-phonefield.lv';
import '../ui-searchinput/ui-searchinput.lv';
import '../ui-signing/ui-signing.lv';
import '../ui-skip-to-content/ui-skip-to-content.lv';
import '../ui-slider/ui-slider.lv';
import '../ui-slides/ui-slides.lv';
import '../ui-stepper/ui-stepper.lv';
import '../ui-table-cloneable/ui-table-cloneable.lv';
import '../ui-table-expandable/ui-table-expandable.lv';
import '../ui-table-sortable/ui-table-sortable.lv';
import '../ui-tabs/ui-tabs.lv';
import '../ui-textcounter/ui-textcounter.lv';
import '../ui-timerange/ui-timerange.lv';
import '../ui-tooltip/ui-tooltip.lv';
import '../ui-upload-item/ui-upload-item.lv';
import '../ui-upload/ui-upload.lv';
import '../ui-video/ui-video.lv';
import '../ui-wizard/ui-wizard.lv';
import '../ui-asset/ui-asset.lv';
import '../ui-slideview/ui-slideview.lv';
import '../ui-rating/ui-rating.lv';
import { Labels } from '../../shared-components/global/labels';
import { Language } from '../../shared-components/global/enums';

Labels.LANGUAGE = Language.Latvian;

window.UI = { ...window.UI, Labels };
